import { render, staticRenderFns } from "./ForumLogs.vue?vue&type=template&id=105f386e&"
import script from "./ForumLogs.vue?vue&type=script&lang=js&"
export * from "./ForumLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports